<script>
  import Loading from '@/icons/Loading.svelte';

  let className = '';
  export {className as class};
  export let minWidth = '';
  export let type = 'default';
  export let size = 'normal';
  export let target = '_self';
  export let href = null;
  export let download = undefined;
  export let disabled = false;
  export let loading = false;
  export let newRadius = false;
  export let style = '';
  export let newGreyStyle = false;
  export let color = '#fff';
</script>

<style>
  button:focus,
  a:focus {
    outline: 0;
  }
  button,
  a {
    display: inline-block;
    border: solid 1px;
    padding: 0 32px;
    line-height: 48px;
    text-align: center;
    cursor: pointer;
  }
  .p024 {
    padding: 0 24px;
  }
  .small {
    padding: 0 16px;
    line-height: 32px;
  }
  button + :global(button) {
    margin-left: 24px;
  }
  .small + :global(.small) {
    margin-left: 12px;
  }
  button :global(svg) {
    display: inline-block;
    transform: scale(0);
    vertical-align: middle;
    -webkit-animation: loading-circle 1s infinite linear;
    animation: loading-circle 1s infinite linear;
    transition: transform 3s linear;
  }
  .default {
    border-color: #dbdfe7;
    background: transparent;
    color: #383838;
  }
  .default:hover {
    border-color: #0046ff;
    color: #0046ff;
  }
  .dark {
    border-color: #e5e5e5;
    background: transparent;
    color: #fff;
  }
  .dark:hover {
    border-color: #0046ff;
    color: #0046ff;
  }
  .text {
    border-color: transparent;
    background: transparent;
    color: #0046ff;
  }
  .text:hover {
    opacity: 0.8;
  }
  .common {
    border-color: #dbdfe7;
    background: #fff;
    color: #010612;
  }
  .common:hover {
    border-color: #0046ff;
    background: #0046ff;
    color: #fff;
  }
  .primary {
    border-color: #0046ff;
    background: #0046ff;
    color: #fff;
  }
  .warning {
    border-color: #ebaf1a;
    background: #ebaf1a;
    color: #fff;
  }
  .danger {
    border-color: #dc4a45;
    background: #dc4a45;
    color: #fff;
  }
  .white {
    border-color: #fff;
    background: #fff;
    color: #0046ff;
  }
  .light {
    border-color: #0046ff;
    background: #fff;
    color: #0046ff;
  }
  .light:hover {
    border-color: #0046ff;
    background: #0046ff;
    color: #fff;
  }
  .golden {
    border-color: #f0bb89;
    background: linear-gradient(135deg, #fde3ca 0%, #f0bb89 100%);
    color: #12192a;
  }
  .grey {
    border: none;
    background: none;
    color: #777b83;
    outline: none;
    text-decoration: underline;
  }
  .primary:hover,
  .warning:hover,
  .danger:hover {
    opacity: 0.8;
  }
  .primary:disabled,
  .warning:disabled,
  .danger:disabled {
    opacity: 0.4;
  }
  a.disabled,
  button:disabled {
    pointer-events: none;
    opacity: 0.4;
  }
  button.greyStyle:disabled {
    border: none;
    font-weight: 500;
    background: #e9ecef;
    color: #9fa3ab;
    outline: none;
    opacity: 1;
  }

  @keyframes loading-circle {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>

{#if href}
  <a
    class:disabled={disabled || loading}
    {download}
    {href}
    {target}
    class="{className} f14"
    class:loading
    class:small={size === 'small'}
    class:default={type === 'default'}
    class:text={type === 'text'}
    class:common={type === 'common'}
    class:primary={type === 'primary'}
    class:warning={type === 'warning'}
    class:danger={type === 'danger'}
    class:golden={type === 'golden'}
    class:dark={type === 'dark'}
    class:white={type === 'white'}
    class:grey={type === 'grey'}
    class:light={type === 'light'}
    class:br8={newRadius}
    class:br2={!newRadius}
    class:greyStyle={newGreyStyle}
    style="min-width: {minWidth ? minWidth : 'auto'};{style}"
    on:click
  >
    <slot />
  </a>
{:else}
  <button
    disabled={disabled || loading}
    class="{className} f14"
    class:loading
    class:small={size === 'small'}
    class:default={type === 'default'}
    class:text={type === 'text'}
    class:common={type === 'common'}
    class:primary={type === 'primary'}
    class:warning={type === 'warning'}
    class:danger={type === 'danger'}
    class:golden={type === 'golden'}
    class:dark={type === 'dark'}
    class:white={type === 'white'}
    class:grey={type === 'grey'}
    class:light={type === 'light'}
    class:br8={newRadius}
    class:br2={!newRadius}
    class:greyStyle={newGreyStyle}
    style="min-width: {minWidth ? minWidth : 'auto'};{style}"
    on:click
  >
    {#if loading}
      <Loading color />
    {/if}
    <slot />
  </button>
{/if}
